import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
//import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
//import Radio from '@material-ui/core/Radio';
//import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';

const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    paper: {
        padding: theme.spacing.unit,
        margin: theme.spacing.unit,
    },
    card: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 18,
      fontWeight: 'bold',
    },
    pos: {
      marginBottom: 12,
    },
    formControl: {
      margin: theme.spacing.unit,
    },
    group: {
      margin: `${theme.spacing.unit}px 0`,
    },
    formLabel: {
        textAlign: 'left',
    },
    formInput: {
        padding: 0,
    },
    greenradio: {
        color: green[600],
        '&$checked': {
            color: green[500],
        },
    },
    redradio: {
        color: red[600],
        '&$checked': {
            color: red[500],
        },
    },
    checked: {},
});

class ClaimENStep1 extends React.Component {
    _isMounted = false;

    state = {
        fp17data: this.props.fp17data,
    };

    componentDidMount() {
        this._isMounted = true; 

        // set any claim defaults
        
        let datatmp = this.state.fp17data;

        //console.log(this.state.fp17data);

        // default start and end date to today
        if (!this.state.fp17data.datacc) {
            datatmp.datacc = moment().format("YYYY-MM-DD");
        }
        if (!this.state.fp17data.datcp) {
            datatmp.datcp = moment().format("YYYY-MM-DD");
        }

        // default no exemption
        if (!this.state.fp17data.exrmcd) {
            datatmp.exrmcd = '0';
        }

        // default band 1 treatment
        if (!this.state.fp17data.claim_band) {
            datatmp.claim_band = '1';
        }  

        // default ethnic origin
        if (!this.state.fp17data.ethorg) {
            datatmp.ethorg = '99';
        }  
        
        //console.log(datatmp);
        this.setState({fp17data: datatmp});

    }

    componentWillUnmount() {
        this._isMounted = false;
    }    

    handleChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let datatmp = this.state.fp17data;
        datatmp[name] = event.target.value;
        this.setState({fp17data: datatmp});        
    };

    async componentWillReceiveProps(nextProps) {
        //console.log(nextProps);
        if (this._isMounted) {
            await this.setState({fp17data: nextProps.fp17data});
        }
    }    

    setBand = event => {
        let datatmp = this.state.fp17data;
        datatmp.ic9164 = '2';
        this.setState({fp17data: datatmp});      
    }

    setToday = event => {
        let datatmp = this.state.fp17data;
        datatmp.datacc = moment().format("YYYY-MM-DD");
        datatmp.datcp = moment().format("YYYY-MM-DD");
        this.setState({fp17data: datatmp});          
    }

    render() {
        const { classes } = this.props;

        return (
        <div className={classes.root}>    
            <Paper className={classes.paper}>
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                    Part 3 Incomplete Treatment and Treatment Dates
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormLabel htmlFor="claim-incomp">Incomplete treatment, Band for actual treatment provided</FormLabel>
                            <Select
                            value={this.state.fp17data.ic9164}
                            onChange={this.handleChange('ic9164')}
                            inputProps={{
                                name: 'ic9164',
                                id: 'claim-incomp',
                            }}
                            >
                                <MenuItem value="99"/>
                                <MenuItem value="1">Band 1</MenuItem>
                                <MenuItem value="2">Band 2a (3 UDA)</MenuItem>
                                <MenuItem value="2">Band 2b (5 UDA)</MenuItem>
                                <MenuItem value="2">Band 2c (7 UDA)</MenuItem>
                                <MenuItem value="3">Band 3</MenuItem>
                            </Select>                    
                        </FormControl>                   
                        </Grid>                                            
                        {/*<Grid item xs={1}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <FormLabel htmlFor="claim-incomp">Incomplete treatment</FormLabel>
                                <RadioGroup
                                    aria-label="Incomplete Treatment"
                                    name="claim-incomp"
                                    className={classes.group}
                                    value={this.state.fp17data.ic9164}
                                    onChange={this.handleChange('ic9164')}
                                    row
                                >
                                    <FormControlLabel value="01" control={<Radio />} label="Band 1" />
                                    <FormControlLabel value="02" control={<Radio />} label="Band 2" />
                                    <FormControlLabel value="03" control={<Radio />} label="Band 3" />
                                    <FormControlLabel value="99" 
                                        control={<Radio className={classes.greenradio}/>} label="Treatment Completed" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <Button variant="contained" color="primary" 
                                onClick={this.setBand}>Set to Band 2</Button>  
                        </Grid>*/}
                        <Grid item xs={12} sm={4} md={3}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                            <TextField
                                required
                                id="claim-datacc"
                                label="Date of Acceptance"
                                type="date"
                                className={classes.textField} 
                                value={this.state.fp17data.datacc}
                                onChange={this.handleChange('datacc')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                />
                            </FormControl>                        
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                            <TextField
                                required
                                id="claim-comp"
                                label="Completion or last visit"
                                type="date"
                                className={classes.textField}
                                value={this.state.fp17data.datcp}
                                onChange={this.handleChange('datcp')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                />
                            </FormControl>                           
                        </Grid>
                    </Grid>
            </Paper>           
        </div>
        );
    }
}

ClaimENStep1.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(ClaimENStep1);